export const APP_VERSION="v0.2.0_pl_live_002 | de7174db071b3bc3d43fbe8086b36efe6807ffe0"
